export function PageNotFound(props)
{
    return <div style={{textAlign:"center"}}>
         <img src="https://i.imgur.com/qIufhof.png" width={Math.min(250,window.innerWidth)} style={{margin:"10px",margin:"auto"}} alt="pagenotfound" />
         <h3>This page could not be found</h3>
    </div>
}